import React, {Component, Fragment} from 'react';
import {Link, withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import {connect} from 'react-redux';
import {signoutUser} from '../../Auth/actions';
import {toggleDrawer, switchDrawer} from '../../Layout/actions';
import HeaderNavigation from './HeaderNavigation';
import {SigninDrawer, SignupDrawer, ForgotPasswordDrawer} from '../../../features/Auth';
import {DashboardDrawer} from '../../../features/Dashboard';
import Button from '@material-ui/core/Button';
import LogoPng from '../assets/img/logo-agep.png';
import LogoSvg from '../assets/img/logo-agep.svg';
import HeaderLanguages from "./HeaderLanguages";
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../translations/translations_header';
import translationsRoutes from "../../../app/router/translations_routes";

const routes = Object.values(translationsRoutes);

class Header extends Component {
    state = {
        isSticky: false,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidMount() {
        this.setStickyHeader();
        window.addEventListener('scroll', this.setStickyHeader);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.auth.isAuthenticated !== this.props.auth.isAuthenticated) {
            if (this.props.auth.isAuthenticated) {
                this.props.switchDrawer('signin', 'dashboard');
            } else {
                this.props.toggleDrawer('dashboard', false);
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.setStickyHeader);
    }

    setStickyHeader = () => {
        let scroll = window.scrollY;

        let isSticky = false;

        if (scroll > 0) {
            isSticky = true;
        }

        const {pathname} = this.props.location;

        const routesWithForcedStickyHeader = [
            routes[0].schools[0],
            routes[0].schools[1],
        ];

        if (routesWithForcedStickyHeader.indexOf(pathname) !== -1) {
            isSticky = true;
        }

        this.setState({
            isSticky: isSticky,
        });
    };

    handleClickSignout = e => {
        e.preventDefault();

        this.props.signoutUser();
    };

    toggleDrawer = (drawer, open) => () => {
        this.props.toggleDrawer(drawer, open);
    };

    render() {
        const {isAuthenticated, user} = this.props.auth;

        let headerClass = '';
        if (this.state.isSticky) {
            headerClass = 'sticky';
        }

        return (
            <Fragment>
                {this.state.isSticky &&
                    <Helmet>
                        <style type="text/css">{`
                            #wrapper main { padding-top: 100px; }
                        `}</style>
                    </Helmet>
                }
                <header id="site-header" className={`${headerClass}`}>
                    <div className="top">
                        <div className="container">
                            <div className="inner">
                                <HeaderLanguages/>
                            </div>
                        </div>
                    </div>
                    <div className="bottom">
                        <div className="container">
                            <Link className="logo" to="/">
                                <object data={LogoSvg} type="image/svg+xml">
                                    <img src={LogoPng} alt={process.env.REACT_APP_SITE_TITLE} />
                                </object>
                            </Link>
                            <HeaderNavigation />
                            <div className="d-block d-md-none">
                                <HeaderLanguages/>
                            </div>
                        </div>
                    </div>
                    <SigninDrawer />
                    <SignupDrawer />
                    <ForgotPasswordDrawer />
                    <DashboardDrawer />
                </header>
            </Fragment>
        );
    }
}

Header.propTypes = {
    auth: PropTypes.object.isRequired,
    layout: PropTypes.object.isRequired,
    signoutUser: PropTypes.func.isRequired,
    toggleDrawer: PropTypes.func.isRequired,
    switchDrawer: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
    layout: state.layout,
});

export default withRouter(connect(mapStateToProps, {signoutUser, toggleDrawer, switchDrawer})(withLocalize(Header)));



// WEBPACK FOOTER //
// ./src/features/Layout/components/Header.js